import React, { useEffect } from 'react';
import { MainTable } from '../../../Components/MainTable/MainTable';
import { useBrands } from './BrandStore';
import Add from './Add';
import Edit from './Edit';

function Brands(props) {
    let { brands, columns, getBrands, deleteBrand, setEd } = useBrands()
    useEffect(() => {
        getBrands()
    }, [])

    return (
        <div>
            <MainTable 
                pageTitle='Markalar'
                pcolumns={columns}
                pdata={brands}
                add={<Add />}
                edit={<Edit />}
                defkey={'id'}
                onDelete={(e, rec)=>{
                    deleteBrand(rec.id)
                }}
                onEdit={(rec)=>{
                    setEd(rec)
                }}
                setEd={setEd}
            />
        </div>
    );
}

export default Brands;